import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { Card, Modal } from "react-bootstrap";
import moment from "moment";
import { academyusergetdetail, listevent } from "../../services/admin";
import { stuacademicyearlist } from "../../services/master";
import { studentdashboardcount } from "../../services/student";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

function Studentdashboard() {
    const navigate = useNavigate();
    const [role, setRole] = useState("");
    const [academy, setAcademy] = useState("");
    const [tlist, setTList] = useState("");
    const [teadet, setTeaDet] = useState();
    const [studet, setStuDet] = useState("");

    const [ayear, setAYear] = useState("");
    const [ylist, setYList] = useState([]);

    const [events, setEvents] = useState([]);


    useEffect(() => {
        if (localStorage.getItem("Role") != 1) {
            academyusergetdetail(localStorage.getItem("UID")).then((res) => {
                if (res.status === true) {
                    setAcademy(res.data.details.academy_name);
                    setRole(res.data.details.role_name);
                }
            });

            setYList([]);
            setAYear("");
            const temp1 = new FormData();
            temp1.append("academy_id", localStorage.getItem("academy"));
            stuacademicyearlist(temp1).then((res) => {
                if (res.status === true) {
                    setYList(res.data);
                }
            });


            setEvents([]);
            const temp = new FormData();
            temp.append("academy_id", localStorage.getItem("academy"));
            listevent(temp).then((res) => {
                if (res.status === true) {
                    setEvents(res.data.details);
                }
            })

            listall("");
        }

    }, []);

    const [todayTimetable, setTodayTimetable] = useState([]);
    const [currentTime, setCurrentTime] = useState(new Date());
    const currentDayIndex = new Date().getDay();
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const currentDay = days[currentDayIndex];
    function listall(lyear) {
        setAYear(lyear);
        setTodayTimetable([]);
        const temp = new FormData();
        temp.append("user_id", localStorage.getItem("UID"));
        temp.append("year", lyear);
        studentdashboardcount(temp).then((res) => {
            if (res.status === true) {
                setStuDet(res.data);
                setTeaDet(res.data.teacher);
                setTList(res.data.students);
                // if (res.data.timetable.length > 0) {
                //     const filteredTimetable = res.data.timetable.filter(item => item[currentDay]);
                //     const updatedTimetable = filteredTimetable.map((item) => {
                //         const timePeriod = item.timeperiod.split(' - ');
                //         const startTime = convertToDate(timePeriod[0]);
                //         const endTime = convertToDate(timePeriod[1]);

                //         const classStatus = checkClassStatus(startTime, endTime);

                //         return {
                //             ...item,
                //             classStatus
                //         };
                //     });
                //     setTodayTimetable(updatedTimetable);
                // }
                if (res.data.timetable.length > 0) {
                    const currentDay = new Date().toLocaleDateString('en-US', { weekday: 'long' }); // e.g., "Thursday"

                    // Filter based on the current day
                    const filteredTimetable = res.data.timetable.filter(item => item.day === currentDay);

                    const updatedTimetable = filteredTimetable.map((item) => {
                        const startTime = convertToDate(item.from_time); // e.g., "09:00"
                        const endTime = convertToDate(item.to_time);     // e.g., "09:45"

                        const classStatus = checkClassStatus(startTime, endTime);

                        return {
                            ...item,
                            classStatus
                        };
                    });
                    setTodayTimetable(updatedTimetable);
                }
            }
        })
    }
    function convertToDate(timeStr) {
        if (!timeStr || typeof timeStr !== 'string') {
            console.warn("Invalid time string:", timeStr);
            return null;
        }

        const today = new Date();
        const [time, modifier] = timeStr.split(' ');

        if (!time || !modifier) {
            console.warn("Time string is not in expected format:", timeStr);
            return null;
        }

        let [hours, minutes] = time.split(':').map(Number);

        if (isNaN(hours) || isNaN(minutes)) {
            console.warn("Invalid time format:", timeStr);
            return null;
        }

        if (modifier === 'PM' && hours !== 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }

        return new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes);
    }


    function checkClassStatus(startTime, endTime) {
        const now = new Date();

        if (now >= startTime && now <= endTime) {
            return "Ongoing";
        } else if (now < startTime) {
            return "Upcoming";
        } else {
            return "Completed";
        }
    }

    const startAutoScroll = () => {
        const scrollContainer = document.getElementById('auto-scroll');
        const announcementList = document.getElementById('announcement-list');

        // Duplicate the list for seamless scrolling
        if (!announcementList.classList.contains('duplicated')) {
            const clone = announcementList.cloneNode(true);
            clone.id = '';
            clone.classList.add('duplicate');
            scrollContainer.appendChild(clone);
            announcementList.classList.add('duplicated');
        }

        const scrollSpeed = 1; // Pixels per step

        if (scrollContainer) {
            window.scrollInterval = setInterval(() => {
                scrollContainer.scrollTop += scrollSpeed;

                // Reset scroll position when reaching the end of the first list
                if (scrollContainer.scrollTop >= announcementList.scrollHeight) {
                    scrollContainer.scrollTop = 0;
                }
            }, 30); // Interval in milliseconds
        }
    };

    // Start auto-scrolling on page load
    document.addEventListener('DOMContentLoaded', startAutoScroll);


    // Start auto-scrolling on page load
    document.addEventListener('DOMContentLoaded', startAutoScroll);

    const [ashow, setAShow] = useState(false);
    const [anndet, setAnnDet] = useState("");
    function handleView(hdata) {
        setAnnDet(hdata);
        setAShow(true);
    }

    function handleAClose() {
        setAShow(false);
        setAnnDet("");
    }

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState("");
    const openModal = (event) => {
        setSelectedEvent(event);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setSelectedEvent("");
        setModalIsOpen(false);
    };

    const handleEventClick = (info) => {
        const clickedEvent = {
            title: info.event.title,
            start: info.event.start,
            end: info.event.end,
            description: info.event.extendedProps.description,
            location: info.event.extendedProps.location,
            circular: info.event.extendedProps.circular === '' ? "" : info.event.extendedProps.path + info.event.extendedProps.circular,
        };
        openModal(clickedEvent);
    };

    function errorphoto(ev) {

        ev.target.src = require("../../assets/images/teacher.jpg");
        ev.target.onerror = null;
    }
    return (
        <Fragment>
            <div className="main-container container-fluid">
                <div className="inner-body">
                    {/* Page Header */}
                    <div className="page-header">
                        <h2 className="main-content-title tx-24 mg-b-5">
                            Welcome To Dashboard
                        </h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a>Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Dashboard
                            </li>
                        </ol>
                    </div>
                    <div className="row row-sm">
                        <div className="col-sm-12 col-lg-12 col-xl-12">
                            <div className="row row-sm">
                                <div className="col-sm-12 col-lg-12 col-xl-12">
                                    <div className="bg-black-2 custom-card card-box card">
                                        <div className="card-body p-4">
                                            <div className="row align-items-center">
                                                <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 img-bg ">
                                                    <h4 className="d-flex  mb-3">
                                                        <span className="font-weight-bold text-white ">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "AMY Technologies Public School"
                                                                : `${academy}`}
                                                        </span>
                                                    </h4>
                                                    <p className="tx-white-7 mb-1">
                                                        Welcome Back{" "}
                                                        <b className="text-warning">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "Student"
                                                                : `${role}`}
                                                        </b>{" "}
                                                        See our Todays Dashboard{" "}
                                                        <b className="text-warning">
                                                            {moment(new Date()).format("DD-MM-YYYY")}
                                                        </b>
                                                        <br></br>
                                                        Have a Nice Day
                                                    </p>
                                                </div>
                                                <img
                                                    src={require("../../assets/images/dashboard/student.png")}
                                                    alt="Student"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {localStorage.getItem("Role") == 1 &&
                                <>
                                    <div className="col-sm-12 col-lg-12 col-xl-12">
                                        <div className="row row-sm">
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">My Unique Number</label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user-circle-o icon-size float-start text-primary"></i><span class="student-no font-weight-bold">AMYS25S1234</span></h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">My Roll Number</label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user icon-size float-start text-primary"></i><span class="student-no font-weight-bold">34</span></h2>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">My Admission Number</label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user-plus icon-size float-start text-primary"></i><span class="student-no font-weight-bold">78934</span></h2>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">My Class</label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-graduation-cap icon-size float-start text-primary"></i><span class="student-no font-weight-bold">III - A</span></h2>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="row row-sm">
                                        <div
                                            className="col-sm-12 col-md-12 col-lg-6 col-xl-4"
                                            data-wow-delay="1.5s"
                                        >
                                            <div class="card custom-card our-team">
                                                <Card.Header>
                                                    <div className="d-md-flex ms-auto">
                                                        <label className="main-content-label my-auto pt-2"><i className="fa fa-user-circle-o headericons"></i> Class Teacher
                                                        </label>
                                                    </div>
                                                </Card.Header>
                                                <div class="card-body" style={{ minHeight: '350px', overflowY: 'auto' }}>
                                                    <div class="picture avatar-lg online text-center">
                                                        <img
                                                            alt="avatar"
                                                            className="rounded-circle"
                                                            src={require("../../assets/images/teacher.jpg")}
                                                        />
                                                    </div>
                                                    <div class="text-center mt-3">
                                                        <h5 class="pro-user-username text-dark mt-2 mb-0">Anand</h5>
                                                        <p class="pro-user-desc text-muted mb-1">Class Teacher</p>
                                                        <span class="badge bg-pill bg-primary-light tx-20">Maths</span>
                                                        <p class="user-info-rating">
                                                            <a><i class="fa fa-star text-warning"> </i></a>
                                                            <a><i class="fa fa-star text-warning"> </i></a>
                                                            <a><i class="fa fa-star text-warning"> </i></a>
                                                            <a><i class="fa fa-star text-warning"> </i></a>
                                                            <a><i class="far fa-star text-warning"> </i></a>
                                                        </p>
                                                    </div>
                                                    <div class="contact-info mb-0 text-center">
                                                        <a class="contact-icon border text-primary" ><i class="fa fa-envelope"></i></a>
                                                        <a class="contact-icon border text-primary" ><i class="fa fa-phone"></i></a>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>



                                        <div
                                            className="col-sm-12 col-md-12 col-lg-6 col-xl-4"
                                            data-wow-delay="1.5s"
                                        >

                                            <Card className="custom-card">
                                                <Card.Header>
                                                    <div className="d-md-flex ms-auto">
                                                        <label className="main-content-label my-auto pt-2"><i className="fa fa-bullhorn headericons"></i> Announcement</label>

                                                    </div>
                                                </Card.Header>
                                                <Card.Body
                                                    id="auto-scroll"
                                                    onMouseEnter={() => clearInterval(window.scrollInterval)}
                                                    // onMouseLeave={startAutoScroll}
                                                    style={{
                                                        maxHeight: '350px',
                                                        overflow: 'hidden',
                                                        position: 'relative',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                    }}
                                                >
                                                    <ul
                                                        className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                        id="announcement-list"
                                                    >
                                                        <li className="d-flex align-items-center mb-3">
                                                            <div className="flex-shrink-0">
                                                                <div className="main-avatar avatar-md online"></div>
                                                            </div>
                                                            <div className="ms-3 flex-grow-1">
                                                                <p className="tx-16 text-dark mb-0 tx-semibold">Happy Tamil New Year</p>
                                                                <p className="mb-0 text-muted tx-16">{moment('2025-04-10').format('DD-MM-YYYY')}</p>
                                                            </div>
                                                            <a class="me-2 mt-1"><span class="badge bg-success-light">View</span></a>
                                                        </li>

                                                    </ul>
                                                </Card.Body>
                                            </Card>
                                        </div>

                                        <div
                                            className="col-sm-12 col-md-12 col-lg-6 col-xl-4"
                                            data-wow-delay="1.5s"
                                        >
                                            <Card className="custom-card">
                                                <Card.Header className="">
                                                    <div className="d-md-flex ms-auto">
                                                        <label className="main-content-label my-auto pt-2"><i className="ti-save-alt headericons"></i> Upcoming Class
                                                        </label>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                                    <ul className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border">
                                                        <li className="media d-flex mb-3 mt-0 pt-0">
                                                            <div className="media-body mb-1 announcement">
                                                                <div className="float-end">
                                                                    <a class="me-2 mt-1">
                                                                        <span className="badge bg-danger-light">Completed</span>
                                                                    </a>
                                                                </div>
                                                                <h5 className="media-title tx-16 mb-0">English<span className="text-danger"> (II-A) </span></h5>
                                                                <p className="mb-0 tx-13 text-muted">
                                                                    09:00 AM - 09:45 AM
                                                                </p>
                                                            </div>
                                                        </li>
                                                        <li className="media d-flex mb-3 mt-0 pt-0">
                                                            <div className="media-body mb-1 announcement">
                                                                <div className="float-end">
                                                                    <a class="me-2 mt-1">
                                                                        <span className="badge bg-info-light">Ongoing</span>
                                                                    </a>
                                                                </div>
                                                                <h5 className="media-title tx-16 mb-0">Maths<span className="text-danger"> (II-A) </span></h5>
                                                                <p className="mb-0 tx-13 text-muted">
                                                                    09:45 AM - 10:30 AM
                                                                </p>
                                                            </div>
                                                        </li>
                                                        <li className="media d-flex mb-3 mt-0 pt-0">
                                                            <div className="media-body mb-1 announcement">
                                                                <div className="float-end">
                                                                    <a class="me-2 mt-1">
                                                                        <span className="badge bg-success-light">Upcoming</span>
                                                                    </a>
                                                                </div>
                                                                <h5 className="media-title tx-16 mb-0">Science<span className="text-danger"> (II-A) </span></h5>
                                                                <p className="mb-0 tx-13 text-muted">
                                                                    10:30 AM - 11:15 AM
                                                                </p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </Card.Body>
                                            </Card>

                                        </div>

                                        {/* <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div className="card custom-card mg-b-20">
                                        <Card className="custom-card">
                                            <Card.Header className="">
                                                <div className="d-md-flex ms-auto">
                                                    <label className="main-content-label my-auto pt-2"><i className="typcn typcn-location headericons"></i> My Bus Location</label>
                                                    <div className="ms-auto mt-3 d-flex">
                                                        <div class="ms-auto">
                                                            <a href="javascript:void(0)" class="option-dots" data-bs-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false"><i
                                                                    class="fe fe-more-vertical"></i></a>
                                                            <div class="dropdown-menu">
                                                                <a class="dropdown-item" href="javascript:void(0)">Add New</a>
                                                                <a class="dropdown-item" href="javascript:void(0)">All Notification</a>
                                                                <a class="dropdown-item" href="javascript:void(0)">Status</a>
                                                                <div class="dropdown-divider"></div>
                                                                <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-cog me-2"></i>
                                                                    Settings</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Header>

                                            <Card.Body>
                                                 <img
                                                    alt="avatar"
                                                    className=""
                                                    src={require("../../assets/images/Advanced-Mapping.jpg")}
                                                /> 
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div> */}

                                        <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                            <Card className="custom-card">
                                                <Card.Header className="">
                                                    <div className="d-md-flex ms-auto">
                                                        <label className="main-content-label my-auto pt-2"><i className="fa fa-calendar headericons"></i> Events calendar</label>

                                                    </div>
                                                </Card.Header>

                                                <Card.Body>
                                                    <FullCalendar
                                                        plugins={[dayGridPlugin]}
                                                        initialView="dayGridMonth"
                                                        events={events.map(event => ({
                                                            title: event.event_name,
                                                            start: event.event_start,
                                                            end: event.event_end || event.event_start,
                                                            description: event.description,
                                                            location: event.location,
                                                            path: event.path,
                                                            circular: event.circular,
                                                            backgroundColor: '#b04751',
                                                            textColor: '#fff'
                                                        }))}
                                                        eventClick={handleEventClick}
                                                    />
                                                </Card.Body>
                                            </Card>

                                        </div>
                                        {/* col end */}
                                    </div>
                                </>
                            }

                            {localStorage.getItem("Role") != 1 && <>
                                <div className="col-sm-12 col-lg-12 col-xl-12">
                                    <div className="row row-sm">
                                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                            <div class="card custom-card student-card">
                                                <div class="card-body">
                                                    <div class="card-order ">
                                                        <label class="main-content-label student-name-card mb-3 pt-1">My Unique Number</label>
                                                        <h2 class="text-end card-item-icon card-icon">
                                                            <i class="fa fa-user-circle-o icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{tlist ? tlist.username : ""}</span></h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                            <div class="card custom-card student-card">
                                                <div class="card-body">
                                                    <div class="card-order ">
                                                        <label class="main-content-label student-name-card mb-3 pt-1">My Roll Number</label>
                                                        <h2 class="text-end card-item-icon card-icon">
                                                            <i class="fa fa-user icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{tlist ? tlist.roll_number : ""}</span></h2>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                            <div class="card custom-card student-card">
                                                <div class="card-body">
                                                    <div class="card-order ">
                                                        <label class="main-content-label student-name-card mb-3 pt-1">My Admission Number</label>
                                                        <h2 class="text-end card-item-icon card-icon">
                                                            <i class="fa fa-user-plus icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{tlist ? tlist.admission_number : ""}</span></h2>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                            <div class="card custom-card student-card">
                                                <div class="card-body">
                                                    <div class="card-order ">
                                                        <label class="main-content-label student-name-card mb-3 pt-1">My Class</label>
                                                        <h2 class="text-end card-item-icon card-icon">
                                                            <i class="fa fa-graduation-cap icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{tlist ? tlist.class_name : ""} - {tlist ? tlist.section_name : ""}</span></h2>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Academic Year<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="default-select  form-control wide"
                                                value={ayear}

                                                onChange={(e) =>
                                                    listall(e.target.value)
                                                }
                                            >
                                                <option value="" disabled>
                                                    Select Academic Year
                                                </option>
                                                {ylist.map((item, i) => {
                                                    return (
                                                        <option value={item.id} key={i}>
                                                            {item.aca_year}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="row row-sm">
                                    <div
                                        className="col-sm-12 col-md-12 col-lg-6 col-xl-4"
                                        data-wow-delay="1.5s"
                                    >
                                        <div class="card custom-card our-team">
                                            <Card.Header>
                                                <div className="d-md-flex ms-auto">
                                                    <label className="main-content-label my-auto pt-2"><i className="fa fa-user-circle-o headericons"></i> Class Teacher
                                                    </label>
                                                </div>
                                            </Card.Header>
                                            <div class="card-body" style={{ minHeight: '350px', overflowY: 'auto' }}>
                                                <div class="picture avatar-lg online text-center">
                                                    <img
                                                        alt="avatar"
                                                        className="rounded-circle"
                                                        // src={require("../../assets/images/teacher.jpg")}
                                                        src={teadet && teadet.photo !== null ? studet.tpath + teadet.photo : require("../../assets/images/teacher.jpg")}
                                                    />
                                                </div>
                                                <div class="text-center mt-3">
                                                    <h5 class="pro-user-username text-dark mt-2 mb-0">{teadet ? teadet.teacher_name : ''}</h5>
                                                    <p class="pro-user-desc text-muted mb-1">Class Teacher</p>
                                                    <span class="badge bg-pill bg-primary-light tx-20">{teadet ? teadet.department : ''}</span>
                                                    <p class="user-info-rating">
                                                        <a><i class="fa fa-star text-warning"> </i></a>
                                                        <a><i class="fa fa-star text-warning"> </i></a>
                                                        <a><i class="fa fa-star text-warning"> </i></a>
                                                        <a><i class="fa fa-star text-warning"> </i></a>
                                                        <a><i class="far fa-star text-warning"> </i></a>
                                                    </p>
                                                </div>
                                                <div class="contact-info mb-0 text-center">
                                                    <a class="contact-icon border text-primary" href={`mailto:${teadet ? teadet.email_id : ''}`} title={teadet ? teadet.email_id : ''}><i class="fa fa-envelope"></i></a>
                                                    <a class="contact-icon border text-primary" href={`tel:${teadet ? teadet.phone : ''}`} title={teadet ? teadet.phone : ''}><i class="fa fa-phone"></i></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>



                                    <div
                                        className="col-sm-12 col-md-12 col-lg-6 col-xl-4"
                                        data-wow-delay="1.5s"
                                    >

                                        <Card className="custom-card">
                                            <Card.Header>
                                                <div className="d-md-flex ms-auto">
                                                    <label className="main-content-label my-auto pt-2"><i className="fa fa-bullhorn headericons"></i> Announcement</label>

                                                </div>
                                            </Card.Header>
                                            <Card.Body
                                                id="auto-scroll"
                                                onMouseEnter={() => clearInterval(window.scrollInterval)}
                                                // onMouseLeave={startAutoScroll}
                                                style={{
                                                    maxHeight: '350px',
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <ul
                                                    className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                    id="announcement-list"
                                                >
                                                    {studet && studet.notification && studet.notification.length > 0 ? (
                                                        studet.notification.map((item, index) => (
                                                            <li key={index} className="d-flex align-items-center mb-3">
                                                                <div className="flex-shrink-0">
                                                                    <div className="main-avatar avatar-md online"></div>
                                                                </div>
                                                                <div className="ms-3 flex-grow-1">
                                                                    <p className="tx-16 text-dark mb-0 tx-semibold">{item.title}</p>
                                                                    <p className="mb-0 text-muted tx-16">{moment(item.created_at).format('DD-MM-YYYY')}</p>
                                                                </div>
                                                                <a class="me-2 mt-1" onClick={() => handleView(item)}><span class="badge bg-success-light">View</span></a>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <h6>No Announcement found.</h6>
                                                    )}

                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    </div>

                                    <div
                                        className="col-sm-12 col-md-12 col-lg-6 col-xl-4"
                                        data-wow-delay="1.5s"
                                    >
                                        <Card className="custom-card">
                                            <Card.Header className="">
                                                <div className="d-md-flex ms-auto">
                                                    <label className="main-content-label my-auto pt-2"><i className="ti-save-alt headericons"></i> Upcoming Class
                                                    </label>
                                                </div>
                                            </Card.Header>
                                            <Card.Body style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                                <ul className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border">
                                                    {todayTimetable.length > 0 ? (
                                                        todayTimetable.map((item) => (
                                                            <li className="media d-flex mb-3 mt-0 pt-0" key={item.id}>
                                                                <img
                                                                    alt="avatar"
                                                                    className="me-3 rounded-circle avatar avatar-md"
                                                                    onError={errorphoto}
                                                                    // src={require("../../assets/images/teacher.jpg")}
                                                                    src={item && item.teacher_photo !== null ? studet.tpath + item.teacher_photo : require("../../assets/images/teacher.jpg")}
                                                                />
                                                                <div className="media-body mb-1 announcement">
                                                                    <div className="float-end">
                                                                        <a class="me-2 mt-1">{item.classStatus === 'Upcoming' ? (
                                                                            <span className="badge bg-success-light">Upcoming</span> // For Upcoming classes
                                                                        ) : item.classStatus === 'Ongoing' ? (
                                                                            <span className="badge bg-info-light">Ongoing</span> // For Ongoing classes
                                                                        ) : (
                                                                            <span className="badge bg-danger-light">Completed</span> // For Completed classes
                                                                        )}</a>
                                                                    </div>
                                                                    <h5 className="media-title tx-16 mb-0">{item.subject_name}<span className="text-danger"> ({item.teacher_name}) </span></h5>
                                                                    <p className="mb-0 tx-13 text-muted">
                                                                        {item.from_time} - {item.to_time} <span className="text-danger"> ({item.slot_name}) </span>
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <h6>No classes for today</h6>
                                                    )}
                                                </ul>
                                            </Card.Body>
                                        </Card>

                                    </div>

                                    {/* <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div className="card custom-card mg-b-20">
                                        <Card className="custom-card">
                                            <Card.Header className="">
                                                <div className="d-md-flex ms-auto">
                                                    <label className="main-content-label my-auto pt-2"><i className="typcn typcn-location headericons"></i> My Bus Location</label>
                                                    <div className="ms-auto mt-3 d-flex">
                                                        <div class="ms-auto">
                                                            <a href="javascript:void(0)" class="option-dots" data-bs-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false"><i
                                                                    class="fe fe-more-vertical"></i></a>
                                                            <div class="dropdown-menu">
                                                                <a class="dropdown-item" href="javascript:void(0)">Add New</a>
                                                                <a class="dropdown-item" href="javascript:void(0)">All Notification</a>
                                                                <a class="dropdown-item" href="javascript:void(0)">Status</a>
                                                                <div class="dropdown-divider"></div>
                                                                <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-cog me-2"></i>
                                                                    Settings</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Header>

                                            <Card.Body>
                                                 <img
                                                    alt="avatar"
                                                    className=""
                                                    src={require("../../assets/images/Advanced-Mapping.jpg")}
                                                /> 
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div> */}

                                    <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <Card className="custom-card">
                                            <Card.Header className="">
                                                <div className="d-md-flex ms-auto">
                                                    <label className="main-content-label my-auto pt-2"><i className="fa fa-calendar headericons"></i> Events calendar</label>

                                                </div>
                                            </Card.Header>

                                            <Card.Body>
                                                <FullCalendar
                                                    plugins={[dayGridPlugin]}
                                                    initialView="dayGridMonth"
                                                    events={events.map(event => ({
                                                        title: event.event_name,
                                                        start: event.event_start,
                                                        end: event.event_end || event.event_start,
                                                        description: event.description,
                                                        location: event.location,
                                                        path: event.path,
                                                        circular: event.circular,
                                                        backgroundColor: '#b04751',
                                                        textColor: '#fff'
                                                    }))}
                                                    eventClick={handleEventClick}
                                                />
                                            </Card.Body>
                                        </Card>

                                    </div>
                                    {/* col end */}
                                </div>
                            </>}

                        </div>



                        <Modal show={ashow} onHide={handleAClose}>
                            <Modal.Header>
                                <Modal.Title>Announcement Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Title</label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{anndet.title}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>
                                                        Message
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{anndet.message}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <a className="btn btn-secondary" onClick={handleAClose}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>


                        <Modal show={modalIsOpen} size="md">
                            <Modal.Header>
                                <Modal.Title>Events</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="table-responsive">
                                    <h4>{selectedEvent.title}</h4>
                                    <p><strong>Start Date :</strong> {moment(selectedEvent.start).format('DD-MM-YYYY')}</p>
                                    <p><strong>End Date :</strong> {selectedEvent.end ? moment(selectedEvent.end).format('DD-MM-YYYY') : moment(selectedEvent.start).format('DD-MM-YYYY')}</p>

                                    <p><strong>Description :</strong> {selectedEvent.description}</p>
                                    {selectedEvent.circular !== "" && <p><strong>Circular:</strong> <a href={selectedEvent.circular} target="_blank" rel="noopener noreferrer">View Circular</a></p>}

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <a className="btn btn-info" onClick={closeModal}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>

                    </div>
                    {/* Row end */}
                </div>
            </div>
        </Fragment>
    );
}


export default Studentdashboard;
